import state from './state';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { Module } from 'vuex';
import RootState from '@/types/store/booking/RootState';
import AuthState from '@/types/store/auth/AuthState';

const module: Module<AuthState, RootState> = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
export default module;
